// @flow
export const isExternal = (location: any) =>
  location.type === 'onstreet' ||
  location.type === 'offstreet' ||
  location.type === 'auxiliary-offstreet' ||
  location.type === 'auxiliary-onstreet';

export const isJp = (location: any) =>
  [
    'justpark',
    'enquiry',
    'driveup',
    'driveup-onstreet',
    'justpark_and_ride'
  ].indexOf(location.type) !== -1;

export const isDriveup = (location: any) =>
  ['driveup', 'driveup-onstreet'].indexOf(location.type) !== -1;

export const isReservable = (location: any) =>
  ['justpark', 'enquiry', 'justpark_and_ride'].indexOf(location.type) !== -1;

export default {
  isJp,
  isExternal
};
